import Network from '../network.js'

export default {
  get(request) {
    return Network.get('/system/app-data', request, true)
  }
}
